<template lang="pug">
  v-container(fluid)
    h1.text-center Inicio
    v-tabs.elevation2.pt-5(v-model="tab"  vertical="vertical")
      v-tabs-slider
      v-tab Tab
        v-icon mdi-person
      v-tab Tab2
        v-icon mdi-person
      v-tab Tab3
        v-icon mdi-person
      v-tab-item
        v-container(fluid)
          v-row(align="center" justify="center")
            ExampleCard(v-for="(item,i) in 5" :key="i")
      v-tab-item
        v-container(fluid)
          v-row(align="center" justify="center")
          v-col.text-center(cols="12")
            v-expansion-panels
              v-expansion-panel(v-for="(item,i) in 5" :key="i")
                v-expansion-panel-header Dropdown
                  v-expansion-panel-content Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.

    v-row(align="center" justify="center")
      v-col.text-center(cols="12")
        h1 Charts
      v-col(cols="12" sm="6" md="4")
        LineChart
      v-col(cols="12" sm="6" md="4")
        BarChart
      v-col(cols="12" sm="6" md="4")
        PieChart
</template>

<script>

  import LineChart from "@/components/charts/LineChart";
  import BarChart from "@/components/charts/BarChart";
  import PieChart from "@/components/charts/PieChart";
  import ExampleCard from "@/components/cards/ExampleCard";

  export default {
    name: 'Fantasy',
    components: {
      ExampleCard,
      PieChart,
      BarChart,
      LineChart
    },
    data: () => ({
      tab:null,
      count:0
    })
  }
</script>

<style lang="sass">
</style>
